import { Component, HostListener, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-header',
  imports: [
    RouterModule,
    MatButtonModule,
    MatIconModule,
    CommonModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  private readonly analytics = inject(AnalyticsService);
  isMobileMenuOpen = false;
  communitiesOpen = false;
  resourcesOpen = false;
  private communitiesCloseTimeout: ReturnType<typeof setTimeout> | null = null;
  private resourcesCloseTimeout: ReturnType<typeof setTimeout> | null = null;

  onDemoCta(): void {
    this.analytics.trackCtaClick('header-book-demo');
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    this.updateBodyScroll();
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
    this.updateBodyScroll();
  }

  private updateBodyScroll(): void {
    if (this.isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  onCommunitiesEnter(): void {
    if (this.communitiesCloseTimeout) {
      clearTimeout(this.communitiesCloseTimeout);
      this.communitiesCloseTimeout = null;
    }
    this.communitiesOpen = true;
  }

  onCommunitiesLeave(): void {
    this.communitiesCloseTimeout = setTimeout(() => {
      this.communitiesOpen = false;
      this.communitiesCloseTimeout = null;
    }, 80);
  }

  onResourcesEnter(): void {
    if (this.resourcesCloseTimeout) {
      clearTimeout(this.resourcesCloseTimeout);
      this.resourcesCloseTimeout = null;
    }
    this.resourcesOpen = true;
  }

  onResourcesLeave(): void {
    this.resourcesCloseTimeout = setTimeout(() => {
      this.resourcesOpen = false;
      this.resourcesCloseTimeout = null;
    }, 80);
  }

  /** Keyboard support: close a dropdown once focus moves outside it. */
  onDropdownFocusOut(event: FocusEvent, menu: 'communities' | 'resources'): void {
    const container = event.currentTarget as HTMLElement | null;
    const next = event.relatedTarget as Node | null;
    if (container && next && container.contains(next)) {
      return;
    }
    if (menu === 'communities') {
      this.onCommunitiesLeave();
    } else {
      this.onResourcesLeave();
    }
  }

  private closeDropdowns(): void {
    if (this.communitiesCloseTimeout) {
      clearTimeout(this.communitiesCloseTimeout);
      this.communitiesCloseTimeout = null;
    }
    if (this.resourcesCloseTimeout) {
      clearTimeout(this.resourcesCloseTimeout);
      this.resourcesCloseTimeout = null;
    }
    this.communitiesOpen = false;
    this.resourcesOpen = false;
  }

  @HostListener('document:keydown.escape')
  handleEscapeKey(): void {
    if (this.isMobileMenuOpen) {
      this.closeMobileMenu();
    }
    this.closeDropdowns();
  }

  /** 992px = Bootstrap lg, matching the d-lg-flex desktop nav. */
  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth >= 992 && this.isMobileMenuOpen) {
      this.closeMobileMenu();
    }
    if (window.innerWidth < 992) {
      this.closeDropdowns();
    }
  }
}
